<template>
<div class="chapter">
<div class="inner_page">
<p class="dedia"><a id="page_vi"></a>For his labor being the unquestionable</p>
<p class="dedia">property of the laborer,</p>
<p class="dedia">no man but he can have a right</p>
<p class="dedia">to what that is once joined to,</p>
<p class="dedia">at least where there is enough, and as good,</p>
<p class="dedia">left in common for others.</p>
<p class="dedia-r"><em>—John Locke (1690)</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication1.vue?1345b754